export const wasUserRedirectedByEmailLoginLink = (): boolean => {
    const searchParams = new URLSearchParams(window.location.search);
    const email = searchParams.get('email');
    const emailLoginToken = searchParams.get('emailLoginToken');
    const wasRedirectedByEmailLoginLink = !!email && !!emailLoginToken;
    return wasRedirectedByEmailLoginLink;
};
